import React from "react";
import classNames from "classnames";
import moment from "moment";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";
import GetUpdatedOnBy from "../GetUpdatedOnBy";
import { LogRenderContext } from "../LogRenderer";

const Pause = ({ name, updatedAt, updatedBy }) => {
  const { log } = React.useContext(LogRenderContext);
  const { statusChangeRequest } = log.changedFields;
  return (
    <div className={styles.tabContainer}>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <div className={styles.badgeContainer}>
          {!!name && <div className={styles.campaignName}>{name}</div>}
          <div className={classNames(styles.badge, styles.badgeWarning)}>
            <div>Paused</div>
          </div>
        </div>
        <GetUpdatedOnBy updatedAt={updatedAt} updatedBy={updatedBy} />
        <InfoBlock
          header="Pause Details"
          className={styles.changeTracking}
          config={[
            {
              title: "Paused Duration",
              size: {
                sm: 6,
                xs: 6,
              },
              value: `${moment(statusChangeRequest?.fromDate).format("MMM DD, YYYY")} - ${moment(
                statusChangeRequest?.toDate
              ).format("MMM DD, YYYY")}`,
            },
            {
              title: "Reason",
              size: {
                sm: 6,
                xs: 6,
              },
              value: statusChangeRequest?.reason,
            },
            {
              title: "Comments",
              size: {
                sm: 6,
                xs: 6,
              },
              value: statusChangeRequest?.comments,
            },
          ]}
        />
      </div>
    </div>
  );
};
export default Pause;
